export default {
  session: 'Session',
  operatingSystem: 'Operating system',
  ip: 'IP',
  currentSession: 'Current session',
  otherSessions: 'Other sessions',
  deleteAll: 'Delete all'
}
